import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';

import { ControlError } from '../../models';

@Component({
  selector: 'kt-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})
export class SelectComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  private _control: FormControl;
  required: boolean;
  showClearBtn: boolean;
  @Input() id: string;
  @Input() label: string;
  @Input() multiple: boolean;
  @Input() canClear = false;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() color: 'primary' | 'secondary' | 'tertiary' | 'neutral' = 'neutral';
  @Input() optionsType: 'LIST' | 'API';
  @Input() options: any[];
  @Input() optionsAPI: (term: string) => Observable<any>;
  @Input() optionType: 'PRIMITIVE' | 'OBJECT';
  @Input() objectOptionReq: {
    idKey: any;
    dataPath?: string;
    labelFormatter?: (option: any) => string;
    valueFormatter?: (option: any) => string;
  };
  @Input() errors: ControlError[] = [];
  @Input()
  set control(control: FormControl) {
    if (!control) return;

    this._control = control;
    this.required = false;

    if (control.validator) {
      const validator = control.validator({} as any);
      this.required = !!validator?.required;
    }
  }
  get control(): FormControl {
    return this._control;
  }

  ngOnInit(): void {
    this.showClearBtn =
      this.canClear && !!(this.multiple ? this.control.value?.length : this.control.value);

    this.subscriptions.add(
      this.control.valueChanges.subscribe((value) => {
        this.showClearBtn = this.canClear && !!(this.multiple ? value?.length : value);
      }),
    );

    if (this.optionsType === 'API' && this.optionsAPI) {
      this.subscriptions.add(
        this.optionsAPI('').subscribe((res) => {
          this.options = res
            ? this.objectOptionReq?.dataPath
              ? res[this.objectOptionReq?.dataPath]
              : res
            : [];
        }),
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  isSelected(option: any): boolean {
    let isSelected: boolean;
    const controlVal = this.control.value;

    if (this.multiple) {
      isSelected = !!controlVal?.find((i) =>
        this.optionType === 'OBJECT'
          ? i[this.objectOptionReq.idKey] === option[this.objectOptionReq.idKey]
          : i === option,
      );
    } else {
      isSelected =
        this.optionType === 'OBJECT'
          ? !!controlVal &&
            controlVal[this.objectOptionReq.idKey] === option[this.objectOptionReq.idKey]
          : controlVal === option;
    }

    return isSelected;
  }

  clearControl(): void {
    this.control.markAsTouched();
    this.control.setValue(null);
  }
}
